// extracted by mini-css-extract-plugin
export var cardLayout = "_9g-1";
export var paginationContainer = "_9g-0";